module.exports = __webpack_public_path__ + "static/img/扫码弹窗@2x.5f14bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/扫码弹窗@2x.png
// module id = 0QC2
// module chunks = 1